export const units = [
  {
    path: '/units',
    name: 'Units',
    component: () => import('./index.vue'),
    meta: {
      rule: 'UNITS',
      requiredAuth: true,
      title: 'general.units',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.units',
          disabled: true,
          href: '#/units'
        }
      ]
    }
  },
  {
    path: '/units/add',
    name: 'addUnits',
    component: () => import('./form.vue'),
    meta: {
      rule: 'UNIT_CREATE',
      requiredAuth: true,
      title: 'units.add',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.units',
          disabled: false,
          href: '#/units'
        },
        {
          text: 'units.add',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/units/add/multiple',
    name: 'addMultipleUnits',
    component: () => import('./multiple.vue'),
    meta: {
      rule: 'UNIT_CREATE',
      requiredAuth: true,
      title: 'units.addMultiple',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.units',
          disabled: false,
          href: '#/units'
        },
        {
          text: 'units.addMultiple',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/units/edit/:id',
    name: 'editUnits',
    component: () => import('./form.vue'),
    meta: {
      rule: 'UNIT_UPDATE',
      requiredAuth: true,
      title: 'units.edit',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.units',
          disabled: false,
          href: '#/units'
        },
        {
          text: 'units.edit',
          disabled: true
        }
      ]
    }
  }
]